import type { ReactNode } from 'react';

import { PostDataContext, type PostDataContextType } from './PostDataContext';

interface PostDataProviderProps extends PostDataContextType {
  children: ReactNode;
}

export const PostDataProvider: React.FC<PostDataProviderProps> = (props) => {
  return (
    <PostDataContext.Provider
      value={{
        post: props.post,
        onlyRenderComments: props.onlyRenderComments,
        isDraft: props.isDraft,
        postMergeTags: props.postMergeTags,
        paywall: props.paywall,
        previewSubscription: props.previewSubscription,
        postMetaInformation: props.postMetaInformation,
        firstCommentsPage: props.firstCommentsPage,
      }}
    >
      {props.children}
    </PostDataContext.Provider>
  );
};
